import {AppPreset, AppQuestion, AppQuestionGroup, IsQuestionGroup} from "../types/types";

export const presetWithErrorItems = (preset: AppPreset): boolean => {
    const hasItemError = (item: AppQuestion): boolean => {
        return !!item.errorText || (item.answers?.some(a => !!a.errorText) ?? false);
    };

    return preset.items?.some(item => {
        if (IsQuestionGroup(item)) {
            return item.views?.some(view =>
                view.questions?.some(question => hasItemError(question))
            ) ?? false;
        }
        return hasItemError(item as AppQuestion);
    }) ?? false;
};

export const filterPresetItemsByName = (preset: AppPreset, name: string): AppPreset => {
    if (!name.trim()) return preset;
    const text = name.toLowerCase();

    const filteredItems: (AppQuestion | AppQuestionGroup)[] = [];

    preset.items.forEach(item => {
        if (!IsQuestionGroup(item)) {
            if (item.name && item.name.toLowerCase().includes(text)) {
                filteredItems.push(item);
            }
        } else {
            const filteredViews = item.views
                ?.map(view => {
                    const matchedQuestions = view.questions.filter(
                        q => q.name && q.name.toLowerCase().includes(text)
                    );
                    return matchedQuestions.length > 0
                        ? {...view, questions: matchedQuestions}
                        : null;
                })
                .filter((v): v is NonNullable<typeof v> => v !== null) ?? [];
            if (filteredViews.length > 0) {
                filteredItems.push({
                    ...item,
                    views: filteredViews
                });
            }
        }
    });
    return {
        ...preset,
        items: filteredItems
    };
}